import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4dd05062"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "no-mb"
}

import { computed, onMounted } from 'vue'
import { generalStore } from '@/stores/general'
import { authStore } from '@/stores/auth'
import { extraStore } from '@/stores/v2/extra'
import WoononSubtotalWidget from '@/components/v2/subtotal/WoononSubtotalWidget.vue'
import WoononSubtotalMobileWidget from '@/components/v2/subtotal/WoononSubtotalMobileWidget.vue'
import WoononExtraProductsDesktop from '@/components/v2/extra/WoononExtraProductsDesktop.vue'
import WoononExtraProductsMobile from '@/components/v2/extra/WoononExtraProductsMobile.vue'
import WoononPhaseTotal from '@/components/v2/WoononPhaseTotal.vue'
import WoononPhaseCreateOrder from '@/components/v2/WoononPhaseCreateOrder.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Extra',
  setup(__props) {

const showProducts = computed(() => extraStore().elements.length > 0 && !authStore().isDemoCustomer)
const orderAllowed = computed(() => !authStore().isDemoCustomer && extraStore().hasSelectedProducts)

onMounted(() => {
  extraStore().getExtraProducts()
})

return (_ctx: any,_cache: any) => {
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createBlock(_component_a_row, {
    class: "extra",
    gutter: [16,4]
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_col, {
        xs: {span: 24},
        sm: {span: 24},
        md: {span: 24},
        lg: {span: 18}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_card, {
            title: "Extra keuzes",
            loading: _unref(extraStore)().loading
          }, {
            default: _withCtx(() => [
              (_unref(showProducts))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (_unref(generalStore)().desktop)
                      ? (_openBlock(), _createBlock(WoononExtraProductsDesktop, { key: 0 }))
                      : (_openBlock(), _createBlock(WoononExtraProductsMobile, { key: 1 })),
                    _createVNode(WoononPhaseTotal, {
                      phase: "extra",
                      phaseLabel: "extra"
                    }),
                    (_unref(orderAllowed))
                      ? (_openBlock(), _createBlock(WoononPhaseCreateOrder, {
                          key: 2,
                          phase: "extra",
                          phaseLabel: "Extra",
                          onOrderCreated: _cache[0] || (_cache[0] = ($event: any) => (_unref(extraStore)().getExtraProducts()))
                        }))
                      : _createCommentVNode("", true)
                  ], 64))
                : (_openBlock(), _createElementBlock("p", _hoisted_1, "Er zijn voor deze fase (nog) geen opties beschikbaar."))
            ]),
            _: 1
          }, 8, ["loading"])
        ]),
        _: 1
      }),
      (_unref(generalStore)().desktop)
        ? (_openBlock(), _createBlock(_component_a_col, {
            key: 0,
            span: 6
          }, {
            default: _withCtx(() => [
              _createVNode(WoononSubtotalWidget)
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(WoononSubtotalMobileWidget, { key: 1 }))
    ]),
    _: 1
  }))
}
}

})